import { Col, Row } from "antd";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import userSelectors from "../../store/user/selectors";
import ActionCards from "./scratch_card/ActionCards";
import ScratchCardList from "./scratch_card/ScratchCardList";
import { userActions } from "../../store/user";
import { useEffect } from "react";

const ScratchCard = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(userActions.getScratchCards());
  }, [dispatch]);
  return (
    <Row className="row-gap">
      <Col span={24}>
        <Row gutter={[30, 20]}>
          <Row className="balance-transfer-cards">
            <ActionCards />
          </Row>
        </Row>
      </Col>
      <Col span={24}>
        <ScratchCardList />
      </Col>
    </Row>
  );
};

export default ScratchCard;
